"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UITruncateString = _interopRequireDefault(require("../../text/UITruncateString"));

var _BrowserTest = require("../../utils/BrowserTest");

// In Firefox, the truncated text will overlap the arrows unless the width is reduced.
var reducedWidthMixin = (0, _styledComponents.css)(["width:calc(100% - 14px);"]);
var SortTH_TruncateString = (0, _styledComponents.default)(_UITruncateString.default).withConfig({
  displayName: "SortTH_TruncateString",
  componentId: "sc-1sfskwh-0"
})(["&&{", ";}"], (0, _BrowserTest.isFirefox)() ? reducedWidthMixin : null);
SortTH_TruncateString.propTypes = _UITruncateString.default.propTypes;
SortTH_TruncateString.defaultProps = _UITruncateString.default.defaultProps;
var _default = SortTH_TruncateString;
exports.default = _default;
module.exports = exports.default;